export default {
  configs: [],
  configsCount: 0,
  query: '',
  limit: 10,
  skip: 0,
  placeCategorySubject: {},
  availableProvinces: [],
  placeSubjectServiceDetail: []
}
